import type koResources from "./resources/ko";

export const SUPPORTED_LANGUAGES = ["ko", "en", "ja", "km"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "ko";

// LanguageDetector(`i18n.ts`) 가 읽는 키와 `useLocale` 이 쓰는 키가 동일해야
// 마운트 hydration 이 깨지지 않으므로 단일 출처에서 export 한다.
export const LANGUAGE_STORAGE_KEY = "ds-locale";

// 메뉴에서 보여줄 자기 언어 표기. 영어로만 표기하면 본인이 모르는 언어 식별 불가.
export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  ko: "한국어",
  en: "English",
  ja: "日本語",
  km: "ខ្មែរ",
};

// 모바일/짧은 트리거에서 보여줄 2~3자 약어
export const LANGUAGE_SHORT_LABELS: Record<SupportedLanguage, string> = {
  ko: "KO",
  en: "EN",
  ja: "JA",
  km: "KM",
};

type KoResources = typeof koResources;
type KoSite = KoResources["landing"]["site"];
type KoManualTopics = KoSite["manual"]["topics"];

/**
 * i18next 가 키를 만드는 리소스 모양 — ko 리소스 그대로이되, 매뉴얼 절 문구(`landing:site.manual.topics`)는 절 이름을 문자열 색인으로 둔다.
 * i18next 는 리소스의 모든 경로(`as const` 배열은 원소마다)로 키 합집합을 만들고 첫 `t()` 에서 전 네임스페이스 몫을 한꺼번에 계산한다 —
 * 절·단계마다 생기는 키 740개가 타입 검사 인스턴스화를 약 25만 개 늘렸다. 화면은 절 문구를 통째로(returnObjects) 읽는다.
 */
type TypedResources = Omit<KoResources, "landing"> & {
  landing: {
    site: Omit<KoSite, "manual"> & {
      manual: Omit<KoSite["manual"], "topics"> & {
        topics: Readonly<Record<string, KoManualTopics[keyof KoManualTopics]>>;
      };
    };
  };
};

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: TypedResources;
  }
}
